import { cn } from "@/lib/utils";

const Heading2 = ({ title, classes }) => {
  return (
    <h2
      className={cn(
        "font-Jost text-center lg:text-6xl text-4xl lg:font-extralight font-light text-lightGray lg:mx-0 mx-4",
        classes
      )}>
      {title}
    </h2>
  );
};

export default Heading2;
